export async function getCompanies(token, id, page_size, page) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/companies/?revenue_targeting_model_id=${id}&page_size=${page_size}&page=${page}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return [];
  }
}
